import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, CardMedia, Input } from "@mui/material";
import SwitchToggle from "../components/SwitchToggle";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddCategory({
  open,
  onClose,
  setOpen,
}: ModalProps) {
  const [image, setImage] = useState<string>("");
  const [iconImage, setIconImage] = useState<string>("");

  const [fileName, setFileName] = useState<string>("");
  const [iconFileName, setIconFileName] = useState<string>("");

  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          {/* MODAL TITLE */}
          <div className="modal_title">
            <h2>Edit Category</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">
            <div className="gap_p">
              {/* UPLOAD IMAGE */}
              <div className="control_group w_50">
                <label htmlFor="upload-category-image">
                  Upload Image<span className="req">*</span>
                </label>

                {image ? (
                  <div className="upload_image no_radius">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="Category" />
                      </figure>
                      <CloseIcon
                        className="remove_img"
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image no_radius"
                    htmlFor="upload-category-image"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="upload-category-image"
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg" }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = event.target.files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/placeholder.png"
                          alt="Upload"
                        />
                        <span className="upload_img_icon">
                          <img
                            src="/static/images/edit2_icon.svg"
                            alt="Edit"
                          />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              {/* UPLOAD ICON (NEW FIELD) */}
              <div className="control_group w_50">
                <label htmlFor="upload-category-icon">
                  Upload Icon<span className="req">*</span>
                </label>

                {iconImage ? (
                  <div className="upload_image no_radius">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={iconImage} alt="Icon" />
                      </figure>
                      <CloseIcon
                        className="remove_img"
                        onClick={() => {
                          setIconImage("");
                          setIconFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image no_radius"
                    htmlFor="upload-category-icon"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="upload-category-icon"
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg, image/svg+xml" }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = event.target.files;
                        if (files && files[0].type.includes("image")) {
                          setIconFileName(files[0].name);
                          setIconImage(URL.createObjectURL(files[0]));
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/placeholder.png"
                          alt="Upload Icon"
                        />
                        <span className="upload_img_icon">
                          <img
                            src="/static/images/edit2_icon.svg"
                            alt="Edit"
                          />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              {/* CATEGORY NAME */}
              <div className="control_group">
                <label htmlFor="reject-reason">Category Name</label>
                <TextField
                  id="reject-reason"
                  placeholder="Enter Name"
                  fullWidth
                  hiddenLabel
                />
              </div>

              {/* Popular */}
              <div className="control_group flex w_100">
                <label>Is this Popular Category?</label>
                <SwitchToggle />
              </div>
            </div>

            {/* FOOTER BUTTON */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}